var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKenteken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230.09,
    height: 49.095,
    viewBox: "0 0 230.09 49.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1449.955 -595.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.357,0H222.643A5.357,5.357,0,0,1,228,5.357V41.649a5.357,5.357,0,0,1-5.357,5.357H5.357A5.357,5.357,0,0,1,0,41.649V5.357A5.357,5.357,0,0,1,5.357,0Z",
    transform: "translate(1451 597.023)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.357-1.045H222.643a6.409,6.409,0,0,1,6.4,6.4V41.649a6.409,6.409,0,0,1-6.4,6.4H5.357a6.409,6.409,0,0,1-6.4-6.4V5.357A6.409,6.409,0,0,1,5.357-1.045ZM222.643,45.96a4.317,4.317,0,0,0,4.312-4.312V5.357a4.317,4.317,0,0,0-4.312-4.312H5.357A4.317,4.317,0,0,0,1.045,5.357V41.649A4.317,4.317,0,0,0,5.357,45.96Z",
    transform: "translate(1451 597.023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.708,10.282V57.118H14.678a3.148,3.148,0,0,1-3.5-2.9l.064-40.335c.257-2.144,1.344-3.459,3.431-3.774Z",
    transform: "translate(1439.893 586.889)",
    fill: "#039",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.642,9.61l18.566.177V57.618H14.678A3.653,3.653,0,0,1,10.689,54.3l-.006-.04v-.04l.064-40.365,0-.029A5.106,5.106,0,0,1,11.9,10.98a4.355,4.355,0,0,1,2.7-1.364Zm17.566,1.167-17.495-.167c-1.779.281-2.723,1.333-2.967,3.3L11.683,54.18a2.657,2.657,0,0,0,3,2.438H32.208Z",
    transform: "translate(1439.893 586.889)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1454.268 604.232)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.578 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.578 13.156)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.305)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.273)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 4.822, 3.268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 3.703, 4.26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.756 9.175) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.163 11.583) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.29) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.564 14.885) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.017)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 1.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.028) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 6.168, 13.165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 1.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.028) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.358, 12.173)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 1.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.028) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.578 4.697) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 1.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.028) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.986 2.29) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.682 1.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.219 1.653) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.844, 1.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.183 0.169) rotate(-18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 1.212) rotate(-162)",
    fill: "#fbbc01"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.694 2.028) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.371 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.556, 1.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.1H.548Z",
    transform: "translate(0.521 0) rotate(18)",
    fill: "#fbbc01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.1V0H.548Z",
    transform: "translate(0.86 1.043) rotate(162)",
    fill: "#fbbc01"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M18.746,62.475v-8.49h1.514l3.155,5.67v-5.67h1.446v8.49H23.3l-3.108-5.536v5.536Zm7.808,0v-8.42h1.556v6.99h3.87v1.43Z",
    transform: "translate(1437.467 572.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.357-1.045H222.643a6.409,6.409,0,0,1,6.4,6.4V41.649a6.409,6.409,0,0,1-6.4,6.4H5.357a6.409,6.409,0,0,1-6.4-6.4V5.357A6.409,6.409,0,0,1,5.357-1.045ZM222.643,45.96a4.317,4.317,0,0,0,4.312-4.312V5.357a4.317,4.317,0,0,0-4.312-4.312H5.357A4.317,4.317,0,0,0,1.045,5.357V41.649A4.317,4.317,0,0,0,5.357,45.96Z",
    transform: "translate(1451 597.023)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenteken);
export default __webpack_public_path__ + "static/media/kenteken.a859ebdbf221ddd918346dc86e1b9786.svg";
export { ForwardRef as ReactComponent };